export enum MarketingEmailTabs {
  General,
  Menu,
  Details,
  SocialMedia,
}
